import React from "react";
import CustomChip from "../../general/chips";

const DeadlineChips = props => {

  let chips = [];
  const { documents, onRemoveDocument, isReconciliationForm } = props;

  Object.keys(documents).forEach(item => {
    chips.push(<CustomChip
      key={`riepilogoDoc_${documents[item].documentId}`}
      closable={true}
      onClose={() => onRemoveDocument(documents[item].documentId)}
      style={{
        marginTop: "10px",
        width: "max-content",
        maxWidth: 400,
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden"
      }}
      description={documents[item].filename}
    />);
  });

  return (
    <div style={{ flex: "0 1 auto", width: isReconciliationForm ? "400px" : "100%" }}>
      <div style={{ display: "flex", flexWrap: "wrap", padding: 5 }}>
        {chips}
      </div>
    </div>
  );

};

export default DeadlineChips;
